<template>
    <v-menu open-on-hover :open-delay="280" :close-on-content-click="false" location="bottom start">
        <template #activator="{ props: menuProps }">
            <span v-bind="menuProps" class="indicador-estado" :class="[
                `indicador-estado--${estado}`,
                { 'indicador-estado--referencia': referencia, 'indicador-estado--compacto': compacto },
            ]" role="button" tabindex="0" :aria-label="`Critérios: ${label}`" :title="compacto ? label : undefined"
                @click.stop>
                <i class="bi" :class="icone"></i>
                <span v-if="!compacto">{{ label }}</span>
                <i v-if="referencia" class="bi bi-info-circle indicador-estado-info" aria-hidden="true"></i>
            </span>
        </template>
        <v-card class="popover-legenda-estado" max-width="340">
            <v-card-title class="popover-legenda-estado-titulo">
                <i class="bi" :class="icone"></i>
                {{ criterios.titulo }}
            </v-card-title>
            <v-card-text class="popover-legenda-estado-corpo">
                <p class="popover-legenda-estado-intro">{{ textoIntro }}</p>
                <ul>
                    <li v-for="(item, index) in criterios.itens" :key="index">{{ item }}</li>
                </ul>
            </v-card-text>
        </v-card>
    </v-menu>
</template>

<script>
import {
    ESTADO_SPRINT_LABEL,
    ESTADO_SPRINT_ICONE,
    ESTADO_SPRINT_CRITERIOS,
    ESTADO_ENTREGA_CRITERIOS,
} from '@/utils/sprintGestao'

/** Rótulos compartilhados (Em dia, Atenção, Crítico) — válidos para sprint e entrega. */
const ESTADO_ENTREGA_LABEL = ESTADO_SPRINT_LABEL

const MAPA_CRITERIOS = {
    entrega: ESTADO_ENTREGA_CRITERIOS,
    sprint: ESTADO_SPRINT_CRITERIOS,
}

const TEXTO_INTRO = {
    entrega: 'O pacote de trabalho é classificado assim quando:',
    sprint: 'A sprint é classificada assim quando:',
}

export default {
    name: 'LegendaEstadoSprint',

    props: {
        estado: {
            type: String,
            required: true,
            validator: (v) => ['ok', 'aviso', 'alerta'].includes(v),
        },
        referencia: {
            type: Boolean,
            default: false,
        },
        /** Na tabela: só ícone, rótulo no tooltip. */
        compacto: {
            type: Boolean,
            default: false,
        },
        /** Contexto dos critérios exibidos no modal: entrega (padrão) ou sprint. */
        contexto: {
            type: String,
            default: 'entrega',
            validator: (v) => ['entrega', 'sprint'].includes(v),
        },
    },

    computed: {
        label() {
            const mapa = this.contexto === 'entrega' ? ESTADO_ENTREGA_LABEL : ESTADO_SPRINT_LABEL
            return mapa[this.estado] || 'Em dia'
        },

        icone() {
            return ESTADO_SPRINT_ICONE[this.estado] || ESTADO_SPRINT_ICONE.ok
        },

        mapaCriterios() {
            return MAPA_CRITERIOS[this.contexto] || ESTADO_ENTREGA_CRITERIOS
        },

        criterios() {
            return this.mapaCriterios[this.estado] || this.mapaCriterios.ok
        },

        textoIntro() {
            return TEXTO_INTRO[this.contexto] || TEXTO_INTRO.entrega
        },
    },
}
</script>

<style scoped>
.indicador-estado {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    font-size: 0.78rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    padding: 0.25rem 0.55rem;
    border-radius: 999px;
    cursor: help;
}

.indicador-estado--referencia {
    cursor: help;
    text-transform: none;
    letter-spacing: normal;
    font-size: 0.75rem;
}

.indicador-estado--compacto {
    padding: 0.35rem 0.45rem;
    font-size: 1rem;
    line-height: 1;
}

.indicador-estado--ok {
    background: hsl(130 40% 92%);
    color: var(--cor-sucesso, #2e7d32);
}

.indicador-estado--aviso {
    background: hsl(45 90% 90%);
    color: hsl(35 80% 32%);
}

.indicador-estado--alerta {
    background: hsl(0 70% 94%);
    color: var(--cor-erro, #c62828);
}

.indicador-estado-info {
    font-size: 0.85rem;
    opacity: 0.65;
}

.popover-legenda-estado {
    font-size: 0.85rem;
}

.popover-legenda-estado-titulo {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    font-size: 0.95rem;
    font-weight: 700;
    padding: 0.75rem 1rem 0.35rem;
    line-height: 1.3;
}

.popover-legenda-estado-corpo {
    padding: 0 1rem 0.85rem;
    color: var(--cor-fonte, #333);
}

.popover-legenda-estado-intro {
    margin: 0 0 0.45rem;
    font-size: 0.8rem;
    color: var(--cor-fonte-fraca, rgba(0, 0, 0, 0.55));
}

.popover-legenda-estado-corpo ul {
    margin: 0;
    padding-left: 1.1rem;
}

.popover-legenda-estado-corpo li {
    margin-bottom: 0.35rem;
    line-height: 1.35;
}

.popover-legenda-estado-corpo li:last-child {
    margin-bottom: 0;
}
</style>
